import moment from "moment";

const formatCurrency = amount => {
  if (isNaN(parseInt(amount))) return "";
  if (parseInt(amount) < 1000) return parseInt(amount);
  return (parseInt(amount) / 1000)
    .toFixed(3)
    .replace(/\d(?=(\d{3})+\.)/g, "$&.");
};

export function formatNumber(value) {
  const val = (value / 1).toFixed().replace(".", ",");
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
function convertDateString(
  inputFormat,
  from = "dd/mm/yyyy",
  to = "yyyy-mm-dd"
) {
  if (from === "dd/mm/yyyy" && to === "yyyy-mm-dd") {
    const d = inputFormat.split("/");
    const dateString = `${d[2]}-${d[1]}-${d[0]}`;
    return dateString;
  }
}
function convertDate(inputFormat) {
  // var date = new Date(inputFormat * 1000);
  // // Hours part from the timestamp
  // var hours = new Date(date).getHours();
  // // Minutes part from the timestamp
  // var minutes = "0" + date.getMinutes();
  // // Will display time in 10:30:23 format
  // var formattedTime = hours + ":" + minutes.substr(-2);
  const hour = moment(inputFormat).hour();
  const minute =
    moment(inputFormat).minute() < 10
      ? `0${moment(inputFormat).minute()}p`
      : `${moment(inputFormat).minute()}p`;

  const formattedTime = `${hour}h${minute}`;

  return formattedTime;
}
function convertDateText(date, format = "HH[h]mm[p]") {
  if (!date) return "";
  const formatInput = "HH:mm:ss,DD-MM-YYYY";
  return moment(date, formatInput).format(format);
}
function formatDate(date, format = "DD/MM/YYYY") {
  if (!date) return "";
  const formatInput = "HH:mm:ss,DD-MM-YYYY";
  return moment(date, formatInput).format(format);
}

function formatDateTime(date, format = "DD/MM/YYYY") {
  if (!date) return "";
  return moment(date).format(format);
}
export function convertDateTimeSecond(inputFormat, format = "DD/MM/YYYY") {
  function pad(s) {
    return s < 10 ? "0" + s : s;
  }
  const d = new Date(inputFormat);
  const time = [
    pad(d.getHours()),
    pad(d.getMinutes()),
    pad(d.getSeconds())
  ].join(":");
  let day = "";
  if (format === "DD/MM/YYYY") {
    day = [pad(d.getFullYear()), pad(d.getMonth() + 1), pad(d.getDate())].join(
      "-"
    );
  } else if (format === "YYYY-MM-DD") {
    day = [pad(d.getFullYear()), pad(d.getMonth() + 1), pad(d.getDate())].join(
      "-"
    );
  }
  return `${day} ${time} `;
}
export function checkPhoneNumber(number) {
  if (/^\+?(840|84).*/.test(number)) {
    return /^\+?(840|84)\d{9,}$/.test(number);
  } else {
    return /^\d{10,}$/.test(number);
  }
}
export function isPhoneNumber(number) {
  return /^\+?(840|84|0)(8[1-9]|9[6-9]|9[0-4]|3[2-9]|70|7[6-9]|5[5-6]|5[8-9])\d{7}$/.test(
    number
  );
}
export function validatePhoneNumber(number) {
  return /^((\+84|0)[35789]\d{8}|(1900|1800|1901|1902)\d{4}|02\d{9})$/.test(
    number
  );
}
function convertDatePlayed(date, format = "HH:mm - DD/MM/YYYY") {
  if (!date) return "";
  const formatInput = "HH:mm:ss,DD-MM-YYYY";
  return moment(date, formatInput).format(format);
}

function mergeArraysByCommonKey(arr1, arr2, key1, key2) {
  return arr1.filter(obj1 => arr2.some(obj2 => obj1[key1] === obj2[key2]));
}

function convertDateTimestamp(timestamp, format = "DD/MM/YYYY") {
  if (!timestamp) return "";
  return moment.unix(timestamp).format(format);
}
function formatPrice(value) {
  let x = value.toString().replaceAll(".", "");
  var pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(x)) x = x.replace(pattern, "$1.$2");
  return x;
}
function convertLargeNumber(number) {
  if (number >= 10 ** 9) {
    // Check if it's an integer or not
    return Number.isInteger(number / 10 ** 9)
      ? `${number / 10 ** 9}B`
      : `${(number / 10 ** 9).toFixed(2)}B`;
  }
  // else if (number >= 10 ** 6) {
  //   // Check if it's an integer or not
  //   return Number.isInteger(number / 10 ** 6)
  //     ? `${number / 10 ** 6} M`
  //     : `${(number / 10 ** 6).toFixed(2)} M`;
  // }
  return `${formatPrice(number.toString())}đ`;
}
export {
  formatCurrency,
  convertDate,
  convertDateString,
  formatDate,
  convertDatePlayed,
  mergeArraysByCommonKey,
  convertDateText,
  convertDateTimestamp,
  formatPrice,
  convertLargeNumber,
  formatDateTime
};
